<script setup>
import { ref, onMounted, watch, nextTick, onBeforeUnmount } from "vue";
import Chart from "chart.js/auto";

const props = defineProps({
  title: String,
  chart: Object,
});

const chartRef = ref(null);
let chartInstance = null;

const renderChart = async () => {
  try {
    // Wait for the canvas to be available in the DOM
    await nextTick();
    
    if (!chartRef.value) {
      console.warn("Canvas element not found");
      return;
    }

    // Destroy previous chart instance if exists
    if (chartInstance) {
      chartInstance.destroy();
      chartInstance = null;
    }

    // Create new chart instance
    const ctx = chartRef.value.getContext("2d");
    chartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels: props.chart?.labels || [],
        datasets: props.chart?.datasets || [],
      },
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              drawBorder: false,
              display: true,
              drawOnChartArea: true,
              drawTicks: false,
              borderDash: [5, 5],
            },
            ticks: {
              display: true,
              padding: 10,
              color: "#9ca2b7",
            },
            title: {
              display: true,
              text: "Estudiantes",
              color: "#9ca2b7",
            },
          },
          y: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: true,
            },
            ticks: {
              display: true,
              color: "#9ca2b7",
              padding: 10,
            },
            title: {
              display: true,
              text: "Cursos",
              color: "#9ca2b7",
            },
          },
        },
      },
    });
  } catch (error) {
    console.error("Error rendering chart:", error);
  }
};

// Watch for chart data changes
watch(
  () => props.chart,
  (newVal) => {
    if (newVal) {
      renderChart();
    }
  },
  { deep: true }
);

// Initialize chart when component mounts
onMounted(() => {
  // Add slight delay to ensure DOM is ready
  setTimeout(renderChart, 100);
});

// Clean up chart when component unmounts
onBeforeUnmount(() => {
  if (chartInstance) {
    chartInstance.destroy();
  }
});
</script>

<template>
  <div class="card h-100">
    <div class="p-3 card-header">
      <h6 class="mb-0">{{ title }}</h6>
    </div>
    <div class="p-3 card-body">
      <div class="chart">
        <canvas ref="chartRef" class="chart-canvas" height="300"></canvas>
      </div>
    </div>
  </div>
</template>